import FaqBoard from "../../components/FaqBoard";
import Pagination from "../../components/Pagination";
import { useState } from "react";
import styles from "../../styles/archive/Faq.module.css";
import classNames from "classnames/bind";
import data from "../../data/faq.json";

const cx = classNames.bind(styles);

export default function Faq() {
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const totalPages = Math.ceil(data.faq.length / pageSize);

  const currentData = data.faq.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div className={cx("faqWrap")}>
      <div className={cx("title")}>
        <h4>FAQ</h4>
      </div>
      <FaqBoard faqData={currentData} />

      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        pagesPerGroup={10}
      />
    </div>
  );
}
